// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"878e1f4f","455":"083b0ca3","977":"8eedb82f"}[chunkId] + ".chunk.js";
};